import React from "react";

export const save_as = (stroke) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 6.35 6.351"
    >
        <g id="layer1" transform="translate(-28.777 -60.739)">
            <g id="g1411">
                <g id="g849" transform="translate(2.83 5.892)">
                    <g id="g3545" transform="translate(11.109 23.466)">
                        <g id="g860" transform="translate(1.003 2.504)">
                            <path
                                id="path912-7"
                                d="M14.892,28.044v0h0l4.071,0-4.071,0h0Z"
                                transform="translate(0.086 1.216)"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path912-2-3"
                                d="M14.9,28.447v0h0l4.058,0-4.058,0h0Z"
                                transform="translate(0.086 1.216)"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path912-5-3"
                                d="M14.9,28.869v0h0l2.1,0-2.1,0h0Z"
                                transform="translate(0.086 1.216)"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path2834-7"
                                d="M20.134,33.672c-.075.254-.259.354-.566.307l-.11-.017-.127-.172c-.195-.262-.512-.687-.935-1.249l-.411-.548-.284-.378c-.342-.455-.339-.451-.36-.531-.011-.041-.06-.222-.109-.4a2.8,2.8,0,0,1-.157-.646c.016-.012-.011-.027.543.3a2.135,2.135,0,0,1,.473.309c.051.064.409.534.583.766l.61.81c.252.335.4.536.647.863.073.1.159.211.192.253l.06.076-.015.1a1.558,1.558,0,0,1-.033.158Zm-.059-.263a3.2,3.2,0,0,0-.265-.34s-.019.05-.037.106a.389.389,0,0,1-.372.321.55.55,0,0,1-.115,0c-.026,0-.048,0-.049,0a2.918,2.918,0,0,0,.319.408.9.9,0,0,0,.245-.037.45.45,0,0,0,.291-.381.108.108,0,0,0-.016-.081Zm-.485-.641-.219-.293-.236-.313c-.171-.226-.291-.385-.516-.68l-.284-.373a2.6,2.6,0,0,0-.208-.262.436.436,0,0,0-.023.11l-.016.111.111.149c.205.275.279.373.9,1.189.291.381.553.718.561.719a.45.45,0,0,0,.019-.11l.012-.111ZM19.418,33c-.231-.314-.366-.494-.763-1.017l-.431-.568-.148-.193-.053-.067-.067.052c-.048.037-.065.057-.06.069s.243.331.532.714L19.2,33.02l.249.331.032-.022a.615.615,0,0,0,.1-.087s-.076-.111-.171-.24Zm-.587-.318-.746-.986-.31-.41-.072,0c-.077,0-.107,0-.108.013s.162.231.745,1.01c.209.279.726.959.774,1.018s.035.051.191.051h.043l-.041-.058c-.022-.032-.237-.318-.476-.634Zm-.805-1.97a.7.7,0,0,0-.226-.16l-.082-.046-.058.088a.327.327,0,0,1-.216.166l-.081.028.016.075c.058.27.067.3.1.3a1.426,1.426,0,0,0,.312-.046.317.317,0,0,0,.159-.131,1.523,1.523,0,0,0,.083-.235.093.093,0,0,0-.005-.04Z"
                                fill={stroke}
                                stroke={stroke}
                                strokeWidth="0.005"
                            />
                            <path
                                id="path2844-3"
                                d="M18.819,31.668h.551V29H14.687v2.692H17.8"
                                fill="none"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path2846-3"
                                d="M18.2,32.246l-3.1-.006v2.831h3.676l.008-2.093h0"
                                fill="none"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path2848-1"
                                d="M15.394,32.59h.87v1.741h-.87Z"
                                fill="none"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                            <path
                                id="path2852-4"
                                d="M19.958,33.159l-.005-4.221H13.9v5.51l.706.718h5.35l0-1.312h0"
                                fill="none"
                                stroke={stroke}
                                strokeWidth="0.122"
                            />
                        </g>
                        <path
                            id="path862"
                            d="M14.892,28.044v0h0l4.07,0-4.07,0h0Z"
                            transform="translate(1.089 3.72)"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path864"
                            d="M14.9,28.447v0h0l4.058,0-4.058,0h0Z"
                            transform="translate(1.089 3.72)"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path866"
                            d="M14.9,28.869v0h0l2.1,0-2.1,0h0Z"
                            transform="translate(1.089 3.72)"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path868"
                            d="M21.137,36.176c-.075.254-.259.354-.566.307l-.11-.017-.127-.172c-.195-.262-.512-.687-.935-1.249l-.411-.548L18.7,34.12c-.342-.455-.339-.451-.36-.531-.011-.041-.06-.222-.109-.4a2.8,2.8,0,0,1-.157-.646c.016-.012-.011-.027.543.3a2.135,2.135,0,0,1,.473.309c.051.064.409.534.583.766l.61.81c.252.335.4.536.647.863.073.1.159.211.192.253l.06.076-.015.1a1.56,1.56,0,0,1-.033.158Zm-.059-.263a3.2,3.2,0,0,0-.265-.34s-.019.05-.037.106A.389.389,0,0,1,20.4,36a.549.549,0,0,1-.115,0c-.026,0-.048,0-.049,0a2.917,2.917,0,0,0,.319.408.9.9,0,0,0,.245-.037.45.45,0,0,0,.291-.381.108.108,0,0,0-.016-.081Zm-.485-.641-.219-.293-.236-.313c-.171-.226-.291-.385-.516-.68l-.284-.373a2.6,2.6,0,0,0-.208-.262.437.437,0,0,0-.023.11l-.016.111.111.149c.205.275.279.373.9,1.189.291.381.553.718.561.719a.449.449,0,0,0,.019-.11l.012-.111Zm-.173.234c-.231-.314-.366-.494-.763-1.017l-.431-.568-.148-.193-.053-.067-.067.052c-.048.037-.065.057-.06.069s.243.331.532.714l.774,1.028.249.331.032-.022a.615.615,0,0,0,.1-.087s-.076-.111-.171-.24Zm-.587-.318-.746-.986-.31-.41-.072,0c-.077,0-.107,0-.108.013s.162.231.745,1.01c.209.279.726.959.774,1.018s.035.051.191.051h.043l-.041-.058c-.022-.032-.237-.318-.476-.634Zm-.805-1.97a.7.7,0,0,0-.226-.16l-.082-.046-.058.088a.327.327,0,0,1-.216.166l-.081.028.016.075c.058.27.067.3.1.3a1.426,1.426,0,0,0,.312-.046.317.317,0,0,0,.159-.131,1.523,1.523,0,0,0,.083-.235.092.092,0,0,0-.005-.04Z"
                            stroke={stroke}
                            strokeWidth="0.005"
                        />
                        <path
                            id="path870"
                            d="M19.822,34.171h.551V31.5H15.69v2.692H18.8"
                            fill="none"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path872"
                            d="M19.207,34.75l-3.1-.006v2.831h3.676l.008-2.093h0"
                            fill="none"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path874"
                            d="M16.4,35.094h.87v1.741H16.4Z"
                            fill="none"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                        <path
                            id="path876"
                            d="M20.961,35.662l-.005-4.221H14.9v5.51l.706.718h5.35l0-1.312h0"
                            fill="none"
                            stroke={stroke}
                            strokeWidth="0.122"
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
